

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { iconos } from "../../../data";





export const BuscarXTerminoAndReturn = ({ termino, chageTermino, texto='no hay datos', playhol='datos', sM=6, mT=1 }) => {


    const navigate = useNavigate();
    const [valor, setValor] = useState(termino);


    const hanldeInputChange = (e) => {
        e.preventDefault();
        const newValor = e.target.value;
        setValor(newValor);

    }


    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const newValor = e.target.value;
            chageTermino(newValor)
        }
    };

    

    return (

        <Grid container sx={{ mt:mT, mb:2, alignItems:"center", justifyContent:'space-between' }} spacing={1} >
            <Grid item xs={12} sm={sM} md={6}>
                <TextField 
                    autoComplete="off"
                    label={`Buscar ${texto}`}
                    variant="outlined" 
                    placeholder={`Buscar x ${playhol}`}
                    fullWidth
                    size="small"
                    name="valor"
                    value={valor}
                    onChange={hanldeInputChange}
                    onKeyDown={handleKeyDown}
                    InputProps={{
                        startAdornment: (<InputAdornment position="start"><Search /></InputAdornment>),
                    }}
                />
            </Grid>

            <Grid item sm="auto" display={{ xs:'none', sm:'flex' }} justifyContent="flex-end">
                <Button variant="contained" color="secondary" onClick={() => navigate(-1)}
                    sx={{ color:'#fff', minWidth:48, minHeight:48, borderRadius:2,
                }}>
                    {iconos['back']}
                </Button>
            </Grid>
        </Grid>
    )
}
